import { useState, useRef, useEffect } from 'react';
import { message, Spin } from 'antd';
import Utils from '@utils/utils'
import API from '@api/api.js';
import ImgComparer from '../imgComparer'
import MagicEraseCanvas from './magicEraseCanvas';
import { forwardRef, useImperativeHandle } from 'react'
import { AppContext } from '@utils/AppContext';
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import eventBus from '@utils/eventBus';
import styles from './index.module.scss'
import { MODESTATE } from '@view/page_v3/AiEdit/CONST'

const MagicErase = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onChange: () => {
            return currentImgRef.current || props.url
        },
        handleDraw,
        repairSizeChange,
        createClick
    }))

    const { getImgWithWatermark, eraserSize, setEraserSize,
        setModeState, setPaintSize, paintSize, modeState,
        isDraw, setIsDraw, setAIEditLoading, AIEditLoading } = useContext(AIEditContext)
    const { setGlobalTaskReadFlag, setAIEditTempProjectId, setSelectedTaskListId, AIEditTemprojectId, selectedTaskListId, AIEditRecentTaskId } = useContext(AppContext)

    const isMounted = useRef(true)
    const drawRef = useRef(null);
    const wrapRef = useRef()
    const [orignPicBase64, setOrignPicBase64] = useState()
    const [orignPic, setOrignPic] = useState();
    const [isLoading1, setIsLoading1] = useState(false);
    const [compareBtn, setCompareBtn] = useState(false);
    const currentImgRef = useRef()
    const [currentImg, setCurrentImg] = useState('');
    const [currentImgWithWatermark, setCurrentImgWithWatermark] = useState('')
    const [reswidth, setWidth] = useState();
    const [resheight, setHeight] = useState()
    const [displayScale, setDisplayScale] = useState(1)
    const imgWidthRef = useRef()
    const [imgWidth, setImgWidth] = useState() // 图片原始宽度
    const imgHeightRef = useRef()
    const [imgHeight, setImgHeight] = useState() // 图片原始高度
    const [redoDataArrLength, setRedoDataArrLength] = useState(0); // 用于恢复撤销
    const [inited, setInited] = useState(false)
    const [fabricInstance, setFabricInstance] = useState()
    const [bgInstance, setBgInstance] = useState()
    const redoDataArrRef = useRef([])
    const dragScaleRef = useRef()
    const taskIDRef = useRef()


    const calcCanvasSize = () => {
        const containerWidth = wrapRef.current?.clientWidth - 120 - 150
        const containerHeight = wrapRef.current?.clientHeight
        const size = Utils.getImgMaxSizeInContainer(
            imgWidthRef.current,
            imgHeightRef.current,
            containerWidth,
            containerHeight
        )
        setDisplayScale(size.width / imgWidthRef.current)
        console.log('size.width / imgWidthRef.current', size.width / imgWidthRef.current)
        setWidth(size.width)
        setHeight(size.height)
    }

    useEffect(() => {
        const onWindowResize = (e) => {
            calcCanvasSize()
        }
        window.addEventListener('resize', onWindowResize)
        return () => {
            isMounted.current = false
            window.removeEventListener('resize', onWindowResize)
        }
    }, [])

    const [ctrlKeyPressed, setCtrlKeyPressed] = useState(false)
    const ctrlKeyPressedRef = useRef(false)
    const keyZPressedRef = useRef(false)
    useEffect(() => {
        const keydown = ev => {
            if ((ev.key == 'Control' || ev.code == 'ControlLeft' || ev.code == 'ControlRight' || ev.keyCode == 17) && !ctrlKeyPressedRef.current) { // ctrl+Z 可撤销操作
                ctrlKeyPressedRef.current = true
                setCtrlKeyPressed(true)
                if (keyZPressedRef.current) {
                    // revoke()
                }
            }
            if ((ev.key == 'z' || ev.code == 'KeyZ' || ev.keyCode == 90) && !keyZPressedRef.current) { // ctrl+Z 可撤销操作
                keyZPressedRef.current = true
                if (ctrlKeyPressedRef.current) {
                    // revoke()
                }
            }
        }
        const keyup = ev => {
            if (ev.key == 'Control' || ev.code == 'ControlLeft' || ev.code == 'ControlRight' || ev.keyCode == 17) {
                ctrlKeyPressedRef.current = false
                setCtrlKeyPressed(false)
            }
            if (ev.key == 'z' || ev.code == 'KeyZ' || ev.keyCode == 90) {
                keyZPressedRef.current = false
            }
        }
        // 监听键盘按下
        document.addEventListener('keydown', keydown)
        document.addEventListener('keyup', keyup)
        return () => {
            document.removeEventListener('keydown', keydown)
            document.removeEventListener('keyup', keyup)
        }
    }, [])

    // 初始化1
    useEffect(() => {
        if (props.url) {
            Utils.urlToBase64(props.url).then(base64 => {
                setOrignPicBase64(base64)
                setOrignPic(props.url)  // 生成图         
            })
        }
    }, [])

    // 初始化2
    useEffect(() => {
        if (!orignPic) return
        Utils.getImageDimensions(orignPic).then(({ width, height }) => {
            imgWidthRef.current = width
            imgHeightRef.current = height
            setImgWidth(width)
            setImgHeight(height)
            calcCanvasSize()
            setInited(true)
        })
    }, [orignPic])

    useEffect(() => {
        redoDataArrRef.current = []
        setRedoDataArrLength(0)
        setIsDraw([])
        clear()
    }, [orignPic])

    const createClick = (val) => {
        setAIEditLoading(true)
        if (!drawRef.current) {
            message.warning('请先返回重新涂抹需要擦除的区域！', 10)
            setAIEditLoading(false)
            return
        }
        Utils.resizeImage(drawRef.current.getDataURL(), imgWidthRef.current, imgHeightRef.current).then((res) => { //  将 mask resize成原图大小
            Utils.convertTransparentWhiteToOpaque(res).then((newBase64Image) => {
                const file = Utils.convertBase64ToFile(newBase64Image)
                Utils.uploadFile(file).then(async url => {
                    if (!url) {
                        setAIEditLoading(false)
                        return
                    }
                    Utils.useroplog(sessionStorage.getItem('oplog_imageType'), 'algorithm', 'aiRemove', { 'AI_edit_pic': orignPic })
                    const res = await API.doMagicErasev2({
                        maskByType: {
                            main: {
                                image: orignPic,
                                binaryMask: url,
                                meta: {},
                                algoId: '',
                                colorMask: ''
                            }
                        },
                        num: 1,
                        projectId: AIEditTemprojectId || '',
                        taskId: '',
                        attr: {},
                    })
                    setGlobalTaskReadFlag(prev => !prev)
                    if (!res) return
                    eventBus.emit('updatePower')
                    const taskId = res.data?.taskList?.[0]
                    setSelectedTaskListId(res.data?.id)
                    setAIEditTempProjectId(res.data?.id)

                    const pollTaskStatus = async () => {
                        if (!isMounted.current) return;
                        const taskInfo = await API.getTaskInfoV2({ taskId })
                        const status = taskInfo.data?.task?.status

                        if (status !== 'succeeded' && status !== 'failed') {
                            setTimeout(() => {
                                pollTaskStatus()
                            }, 1000);
                        } else {
                            if (status === 'succeeded') {
                                eventBus.emit('updatePower')
                                const noWaterImage = await API.commonDownload({ taskId: taskInfo.data?.task?.taskId })
                                if (!noWaterImage) return
                                message.success('处理成功！', 5000)
                                currentImgRef.current = noWaterImage.data
                                taskIDRef.current = taskInfo.data?.task?.taskId
                                setCurrentImg(noWaterImage.data)
                                setOrignPic(noWaterImage.data)
                                downloadUrl.current = null
                                setAIEditLoading(false)
                            } else if (status === 'failed') {
                                eventBus.emit('updatePower')
                                console.log('Task failed')
                                message.error('处理失败！', 5000)
                                setAIEditLoading(false)
                            }
                        }
                    }
                    pollTaskStatus()
                })
            })
        })
    }

    const repairSizeChange = (value, key) => {
        setModeState(key)
        if (key == MODESTATE.PAINT) {
            setPaintSize(value)
        } else if (key == MODESTATE.ERASER) {
            setEraserSize(value)
        }
    }

    const handleDraw = (key) => {
        clear()
        redoDataArrRef.current = []
        setRedoDataArrLength(0)
        setIsDraw([])
    }
    const undo = () => {
        const saveData = drawRef.current.getSaveData()
        console.log(saveData)
        redoDataArrRef.current.push(saveData)
        setIsDraw(saveData.lines)
        setRedoDataArrLength(redoDataArrRef.current.length)
        drawRef.current.undo()
    }
    const redo = () => {
        if (redoDataArrRef.current.length <= 0) return
        const redoData = redoDataArrRef.current.pop();
        drawRef.current.loadSaveData(redoData)
        setRedoDataArrLength(redoDataArrRef.current.length)
    }
    const clear = () => {
        if (!drawRef.current) return
        drawRef.current.clear()
    }

    const resetClick = () => {
        setCompareBtn(false)
        currentImgRef.current = null
        setCurrentImg()
        setOrignPic(props.url)
        downloadUrl.current = null
        dragScaleRef.current.resetCanvas()
    }

    const compareClick = () => {
        if (!compareBtn) {
            getImgWithWatermark(currentImg).then(base64 => {
                setCurrentImgWithWatermark(base64)
                setCompareBtn(true)
            })
        } else {
            setCompareBtn(false)
        }
    }

    const downloadUrl = useRef()
    async function commonDownloadFunc() {
        // 需要登录
        const status = Utils.checkLoginStatus(() => commonDownloadFunc())
        if (!status) return
        try {
            let res = await API.commonDownload({ taskId: taskIDRef.current || AIEditRecentTaskId })

            if (res?.code != 0) throw new Error(res?.message)
            const image = res.data
            Utils.downUrl(image, 'aiEdit')
            message.success('下载成功');
        } catch (err) {
            message.error(err.message)
        }
    }

    const getIsDraw = (lineArr) => {
        setIsDraw(lineArr)
    }

    const [moveable, setMoveable] = useState()
    const onDragAndScaleChange = ({ moveable }) => {
        setMoveable(moveable)
    }

    useEffect(() => {
        if (!props.onBottomConfigChange) return
        props.onBottomConfigChange(
            inited ? {
                compare: { disabled: !currentImg, trigger: compareClick },
                revoke: { disabled: isDraw.length == 0, trigger: undo },
                restore: { disabled: redoDataArrLength == 0, trigger: redo },
                reset: { disabled: !currentImg, trigger: resetClick },
                download: { disabled: !currentImg && !AIEditRecentTaskId, trigger: commonDownloadFunc },
                remove: { disabled: false, trigger: props.handleCleanClick },
                uploadCb: props.uploadCb,
                scale: (fabricInstance && bgInstance) ? {
                    ref: dragScaleRef,
                    zoomAllowed: !ctrlKeyPressed,
                    min: 1,
                    max: 8,
                    onChange: onDragAndScaleChange,
                    canvasList: [fabricInstance, bgInstance],
                    disabled: compareBtn ? true : false,
                    options: [
                        { label: '适应屏幕', value: 1 },
                        { label: '100%', value: 1 },
                        { label: '200%', value: 2 },
                        { label: '300%', value: 3 },
                        { label: '400%', value: 4 },
                    ]
                } : null
            } : null
        )
        return () => {
            props.onBottomConfigChange(null)
        }
    }, [inited, compareBtn, currentImg, isDraw, redoDataArrLength, AIEditRecentTaskId, fabricInstance, bgInstance, ctrlKeyPressed, props.uploadCb])

    const loadingBox = (
        <div className={styles.loadingBox}>
            <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/loadingBlue.gif" alt="" />
            <p>云端处理中，马上好~</p>
        </div>
    )

    const rightContent = (
        <div className={styles.aiBeautyContent_} style={{ position: 'relative' }} ref={wrapRef}>
            {
                inited ?
                    <div className={styles.aiBeautyContent_Item}>
                        <div className={styles.aiBeautyContent_Scale}></div>
                        {
                            compareBtn &&
                            <div style={{ height: resheight, width: reswidth }} >
                                <ImgComparer
                                    leftImage={props.url}
                                    rightImage={currentImgWithWatermark}
                                />
                            </div>
                        }
                        <div
                            style={{
                                position: compareBtn ? 'absolute' : 'relative',
                                top: compareBtn ? '-9999px' : '0',
                                left: compareBtn ? '-9999px' : '0',
                                height: resheight,
                                width: reswidth
                            }}
                        >
                            <MagicEraseCanvas
                                ref={drawRef}
                                handleCleanClick={props.handleCleanClick}
                                size={modeState == MODESTATE.PAINT ? paintSize : eraserSize}
                                url={orignPic}
                                moveable={moveable}
                                displayScale={displayScale}
                                displayWidth={reswidth}
                                displayHeight={resheight}
                                ctrlKeyPressed={ctrlKeyPressed}
                                setFabricInstance={(a, b) => { setBgInstance(a); setFabricInstance(b) }}
                                getIsDraw={getIsDraw}
                                changeBrushSize={offset => setEraserSize(pre => pre + offset)}
                            />
                        </div>
                    </div> : loadingBox
            }
            {
                AIEditLoading && loadingBox
            }

        </div>
    )


    return (
        <div className={styles.aiBeauty}>
            <div
                className={styles.aiBeautyContent}
                style={{ borderRadius: inited ? '0 0 16px 16px' : '16px' }}
            >
                {
                    !props.url ?
                        props.defaultPage :
                        rightContent
                }
            </div>
        </div>
    )
})

export default MagicErase;
